import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { toast } from "sonner";
import { KeyRound, Save, Lock } from "lucide-react";
import { useApp } from "../../contexts/AppContext";

const EMPTY = {
  teacher_pw_training: "",
  teacher_pw_competition: "",
  teacher_pw_prompt_training_pt: "",
  teacher_pw_prompt_training_br: "",
  teacher_pw_prompt_training_en: "",
  teacher_pw_prompt_competition_pt: "",
  teacher_pw_prompt_competition_br: "",
  teacher_pw_prompt_competition_en: "",
};

function Section({ title, pwField, promptBase, accent, form, onChange }) {
  return (
    <div className="rounded-2xl bg-white p-6 border border-[#0B1D3A]/5 shadow-[0_8px_30px_-12px_rgba(11,29,58,0.12)] space-y-4">
      <div className="flex items-center gap-3">
        <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl" style={{ background: accent + "18", color: accent }}>
          <Lock size={18} />
        </span>
        <h2 className="font-fredoka text-xl font-bold text-[#0B1D3A]">{title}</h2>
      </div>
      <label className="block text-sm font-semibold text-[#0B1D3A]">Senha (deixe em branco para não pedir)
        <input type="text" value={form[pwField] || ""} onChange={(e) => onChange(pwField, e.target.value)}
          placeholder="Sem senha" autoComplete="off"
          className="mt-1 block w-full max-w-xs px-3 py-2 rounded-lg border border-[#0B1D3A]/15 font-mono"
          data-testid={`tp-${pwField}`} />
      </label>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {[["pt", "Texto (PT)"], ["br", "Texto (BR)"], ["en", "Texto (EN)"]].map(([lng, lbl]) => (
          <label key={lng} className="block text-sm font-semibold text-[#0B1D3A]">{lbl}
            <input type="text" value={form[`${promptBase}_${lng}`] || ""} onChange={(e) => onChange(`${promptBase}_${lng}`, e.target.value)}
              className="mt-1 block w-full px-3 py-2 rounded-lg border border-[#0B1D3A]/15 font-normal text-sm"
              data-testid={`tp-${promptBase}-${lng}`} />
          </label>
        ))}
      </div>
    </div>
  );
}

export default function AdminTeacherPassword() {
  const { refreshSettings } = useApp();
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/teacher-passwords").then((r) => setForm({ ...EMPTY, ...r.data })).catch(() => {});
  }, []);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/teacher-passwords", form);
      await refreshSettings();
      toast.success("Senhas de professor guardadas");
    } catch (_) { toast.error("Erro ao guardar"); }
    finally { setSaving(false); }
  };

  return (
    <div data-testid="admin-teacher-password">
      <div className="flex items-center gap-3 mb-2">
        <KeyRound className="text-[#005F73]" />
        <h1 className="font-fredoka text-3xl font-bold text-[#0B1D3A]">Senha de professor</h1>
      </div>
      <p className="font-nunito text-sm text-[#0B1D3A]/60 mb-6 max-w-2xl">
        Defina uma senha para aceder aos quizzes. Se o campo ficar <b>em branco</b>, não será pedida senha para jogar.
        O texto apresentado ao utilizador é editável em cada idioma.
      </p>

      <div className="space-y-6 max-w-3xl">
        <Section title="Quizzes de treino" pwField="teacher_pw_training" promptBase="teacher_pw_prompt_training" accent="#2D9C5A" form={form} onChange={set} />
        <Section title="Quizzes de concurso" pwField="teacher_pw_competition" promptBase="teacher_pw_prompt_competition" accent="#C1121F" form={form} onChange={set} />

        <button onClick={save} disabled={saving}
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#005F73] text-white font-bold disabled:opacity-50"
          data-testid="tp-save-btn">
          <Save size={18} /> {saving ? "A guardar..." : "Guardar senhas"}
        </button>
      </div>
    </div>
  );
}
